// extracted by mini-css-extract-plugin
export default {"ReplyButton":"px_a bic_wx bic_jb bic_xl bic_i bic_j bic_q bic_vt bic_et bic_so bic_sp bic_eg","ReplyButton__icon":"px_b bic_rz"};